module.exports = __webpack_public_path__ + "img/notification-close.2cf73270.svg";